import { IGetRegionResponseSchema } from '../../../repositories/monolith-python/entities/schemas/GetRegionResponseSchema';
import type { IOption } from '@cian/ui-kit/types/option';

/**
 * Формирует опции селектора для филда Регион
 */
export const getRealtorRatingRegionFieldOptions = (regionItems: IGetRegionResponseSchema[]): IOption[] => {
  return [
    { value: 0, label: 'Любой' },
    ...regionItems.map(({ id, displayName }) => ({ value: id, label: displayName })),
  ];
};
